import { Button, FormInput, Modal } from '@/components/UI';
import FormSwitch from '@/components/UI/FormSwitch';

interface PromoteBundleModalProps {
    resultIds: number[] | null;
    selectedJobId: number | null;
    strategyId?: number | null;
    bundlePromotionName: string;
    setBundlePromotionName: (value: string) => void;
    bundlePromotionDescription: string;
    setBundlePromotionDescription: (value: string) => void;
    bundlePromotionIsActive: boolean;
    setBundlePromotionIsActive: (value: boolean) => void;
    bundlePromotionAttachToStrategy: boolean;
    setBundlePromotionAttachToStrategy: (value: boolean) => void;
    isWorking: boolean;
    onClose: () => void;
    onPromote: () => void;
}

const PromoteBundleModal = ({
    resultIds,
    selectedJobId,
    strategyId,
    bundlePromotionName,
    setBundlePromotionName,
    bundlePromotionDescription,
    setBundlePromotionDescription,
    bundlePromotionIsActive,
    setBundlePromotionIsActive,
    bundlePromotionAttachToStrategy,
    setBundlePromotionAttachToStrategy,
    isWorking,
    onClose,
    onPromote
}: PromoteBundleModalProps) => {
    return (
        <Modal isOpen={resultIds !== null} size="lg" title="Create OR Bundle" onClose={onClose}>
            {resultIds && (
                <>
                    <div className="text-zinc-400 text-sm mb-3">
                        jobId={selectedJobId ?? '?'} results={resultIds.length}
                    </div>

                    <div className="text-zinc-500 text-xs mb-3">
                        OR bundle means: (rule #1) OR (rule #2) OR … Each underlying rule stays an AND group.
                    </div>

                    <div className="space-y-3">
                        <FormInput
                            id="opt-promote-bundle-name"
                            label="Screener Name"
                            value={bundlePromotionName}
                            onChange={(e) => setBundlePromotionName(e.target.value)}
                        />
                        <FormInput
                            id="opt-promote-bundle-description"
                            label="Description"
                            placeholder="Optional"
                            value={bundlePromotionDescription}
                            onChange={(e) => setBundlePromotionDescription(e.target.value)}
                        />
                        <div className="flex items-center justify-between">
                            <FormSwitch
                                checked={bundlePromotionIsActive}
                                id="opt-promote-bundle-is-active"
                                label="Rule is active"
                                onChange={(e) => setBundlePromotionIsActive(e.target.checked)}
                            />
                            {strategyId ? (
                                <FormSwitch
                                    checked={bundlePromotionAttachToStrategy}
                                    id="opt-promote-bundle-attach-strategy"
                                    label="Attach to strategy"
                                    onChange={(e) => setBundlePromotionAttachToStrategy(e.target.checked)}
                                />
                            ) : (
                                <div className="text-zinc-500 text-sm">No strategy attached to this experiment.</div>
                            )}
                        </div>

                        <div className="flex items-center justify-end gap-2 pt-2">
                            <Button variant="secondary" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button disabled={isWorking} variant="primary" onClick={onPromote}>
                                {isWorking ? 'Working…' : 'Create bundle'}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </Modal>
    );
};

export default PromoteBundleModal;
